import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import './Banner.css';

const CounterSection = () => {
  
    const [counter, setCounter] = useState([]);
      const [page, setPage] = useState([]);
        const { pageSlug } = useParams(); // Extract the blog post titleSlug from the URL
    
      useEffect(() => {
        fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/counters`)
          .then((res) => res.json())
          .then((info) => setCounter(info));
      }, []);
    
       useEffect(() => {
          fetch(`https://healthkeywordresearch01-5ec078e699df.herokuapp.com/page/${pageSlug}`)
            .then((res) => res.json())
            .then((info) => setPage(info))
            .catch((error) => console.error("Error fetching banners:", error));
        }, []);



    return (


        <>


        {
            counter.map(b => b.pageSlug === page.pageSlug &&
            <div id="statistic-1" className="statistic-1 bg-primary-color tra-pattern statistic-section division">
                <div className="container white-color">
                    <div className="row">
                        {/* STATISTIC BLOCK #1 */}
                        <div className="col-sm-6 col-md-3">
                            <div className="statistic-block text-center wow fadeInUp" data-wow-delay="0.4s">
                                {/* Icon  */}
                                <div className="statistic-ico ico-60"><span className="flaticon-harddisk-1" /></div>
                                {/* Text */}
                                <h5 className="statistic-number"><span className="count-element">{b.projectCompleteNumber}</span></h5>
                                <p className="p-md">{b.projectCompleteText}</p>
                            </div>
                        </div>
                        {/* STATISTIC BLOCK #2 */}
                        <div className="col-sm-6 col-md-3">
                            <div className="statistic-block text-center wow fadeInUp" data-wow-delay="0.6s">
                                {/* Icon  */}
                                <div className="statistic-ico ico-60"><span className="flaticon-chat-3" /></div>
                                {/* Text */}
                                <h5 className="statistic-number"><span className="count-element">{b.happyClientsNumber}</span></h5>
                                <p className="p-md">{b.happyClientsText}</p>
                            </div>
                        </div>
                        {/* STATISTIC BLOCK #3 */}
                        <div className="col-sm-6 col-md-3">
                            <div className="statistic-block text-center wow fadeInUp" data-wow-delay="0.8s">
                                {/* Icon  */}
                                <div className="statistic-ico ico-60"><span className="flaticon-users-1" /></div>
                                {/* Text */}
                                <h5 className="statistic-number"><span className="count-element">{b.teamNumber}</span></h5>
                                <p className="p-md">{b.teamText}</p>
                            </div>
                        </div>
                        {/* STATISTIC BLOCK #4 */}
                        <div className="col-sm-6 col-md-3">
                            <div className="statistic-block text-center wow fadeInUp" data-wow-delay="1s">
                                {/* Icon  */}
                                <div className="statistic-ico ico-60"><span className="flaticon-help" /></div>
                                {/* Text */}
                                <h5 className="statistic-number"><span className="count-element">{b.yearofExperienceNumber}</span></h5>
                                <p className="p-md">{b.yearofExperienceText}</p>
                            </div>
                        </div>
                    </div>  {/* End row */}
                </div>	 {/* End container */}
            </div>)}

        

    </>
    );
};

export default CounterSection;
